import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@shape-ds/components';

type TooltipContentProps = { children: React.ReactNode };

const TooltipInfo: React.FC<TooltipContentProps> = ({ children }) => {
  return (
    <Tooltip
      followCursor={false}
      placement="top"
      title={children}
      customStyle={{ width: '1rem', height: '1rem' }}
      style={{ lineHeight: '16px', fontSize: '12px' }}
    >
      <InfoOutlinedIcon style={{ width: '1rem', height: '1rem' }} />
    </Tooltip>
  );
};

export default TooltipInfo;
